export default __webpack_public_path__ + "static/media/landing-card-4.dfe2ae1e.jpeg";